import { render } from "./approveModal.vue?vue&type=template&id=31908e5d"
import script from "./approveModal.vue?vue&type=script&lang=js"
export * from "./approveModal.vue?vue&type=script&lang=js"

import "./approveModal.vue?vue&type=style&index=0&id=31908e5d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__